// import Swiper JS
import Swiper, { Navigation, Autoplay, Scrollbar} from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';


function initSwiper_reviews(){
  // configure Swiper to use modules
  Swiper.use([Navigation, Autoplay, Scrollbar]);

  var cardSlider = new Swiper('.desk_grid_mob_slider', {
    slidesPerView: 1.3,
    spaceBetween: 20,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1220: {
        slidesPerView: 3,
      }
    }
  });
}

jQuery(document).ready(function() {
  setTimeout(function(){
      initSwiper_reviews();
  }, 100);
});